import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import s from './ContentTextRenderer.scss';
var ContentTextRenderer = function (_a) {
    var comment = _a.comment;
    var commentId = comment.commentId, textContent = comment.textContent;
    return (React.createElement("div", { "data-hook": BiDataHook.COMMENT_BODY },
        React.createElement(TextRenderer, { className: s['renderer'], textContent: textContent, reactViewer: CommentViewer, legacyTheme: 'comments', viewerKey: commentId })));
};
ContentTextRenderer.displayName = 'ContentTextRenderer';
export default ContentTextRenderer;
//# sourceMappingURL=ContentTextRenderer.js.map